import { getBooleanFromString } from '../../utils/string-utils';
import { isArticlePage, isLiveBlogPage, isNewsYouCanUsePage, isVideoArticlePage } from '../../utils/aem-utils';
import { VIDEO_PLAYER_POSITIONS, VIDEO_PLAYER_PLAYERTYPE, VIDEO_PLAYER_CONTEXT } from '../video-player/constants';
import { isWidthDeviceMobileTablet } from '../../utils/device-utils';

const PROGRESS_BAR_CLASSNAME_SELECTOR = '.c-reading-progress-bar';
const MEDIA_WRAPPER_TOP_BG_CLASSNAME = 'c-hero__media-wrapper--top-bg';
const MEDIA_WRAPPER_STICKY_PLAYER_CLASSNAME = 'c-hero__media-wrapper--sticky-player';
const MEDIA_PLACEHOLDER_CLASSNAME = 'c-hero__media-placeholder';
const MOBILE_STICKY_WRAPPER_TOP_VALUE = isLiveBlogPage() ? 61 : 65;
const $player = document.querySelector('.j-intro .j-player');
const $mediaWrapper = document.querySelector('.c-hero__media-wrapper');
const $LMPHero = document.querySelector('.ftbl__hero-lmp');
const $F1Hero = document.querySelector('.ftbl__lgp-hero-container.j-intro');

export const isLMPArticle = $LMPHero || $F1Hero;

export const isStickyEnabled = () => {
  if (isNewsYouCanUsePage() && $player) {
    return true;
  }
  return document.querySelector('[data-sticky-enabled]')
    ? getBooleanFromString(document.querySelector('[data-sticky-enabled]').dataset.stickyEnabled) && $player
    : false;
};

export const isPlayerInStickyPosition = () => {
  return $player.dataset.state === VIDEO_PLAYER_POSITIONS.STICKY;
};

export const isStickyLargeEnabled = () => {
  return isArticlePage() || isNewsYouCanUsePage() || isLiveBlogPage() || isVideoArticlePage();
};

export const getVideoPlayer = (players) => {
  let playerInstance;
  players?.playerConfigList?.forEach((playerConfig, index) => {
    if (
      playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.HERO ||
      playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.LMP_STICKY
    ) {
      playerInstance = players.playerList[index];
    }
  });
  return playerInstance;
};

export const isReadingProgressInPage = () => {
  return Boolean(document.querySelector(PROGRESS_BAR_CLASSNAME_SELECTOR));
};

export const enableStickyElementAttributes = (players) => {
  if (isStickyLargeEnabled()) {
    $player.setAttribute('data-sticky-large', true);
  }
  const playerIstance = getVideoPlayer(players);
  playerIstance.setContext(VIDEO_PLAYER_CONTEXT.STICKY);
  $player.dataset.state = VIDEO_PLAYER_POSITIONS.STICKY;
};

export const disableStickyElementAttributes = (players) => {
  const playerIstance = getVideoPlayer(players);
  playerIstance.setContext(VIDEO_PLAYER_CONTEXT.PAGE);
  $player.dataset.state = VIDEO_PLAYER_POSITIONS.DEFAULT;
};

export const enableStickyElementDesktop = () => {
  $player.style.position = 'fixed';
};

export const disableStickyElementDesktop = () => {
  $player.style.position = 'relative';
};

// We are going to create a placeholder div that acts as the player container to
// prevent the page from jumping when the player is in fixed position

export const createPlaceholderDiv = () => {
  const $existingPlaceholderDiv = document.querySelector(`.${MEDIA_PLACEHOLDER_CLASSNAME}`);
  if ($existingPlaceholderDiv) {
    return;
  }
  const $placeholderDiv = document.createElement('div');
  $placeholderDiv.classList.add(MEDIA_PLACEHOLDER_CLASSNAME);
  $placeholderDiv.style.height = parseInt($player.style.height, 10) > 250 ? '250px' : $player.style.height;
  $mediaWrapper.parentElement.insertBefore($placeholderDiv, $mediaWrapper);
};

const removePlaceholderDiv = () => {
  const $placeholderDiv = document.querySelector(`.${MEDIA_PLACEHOLDER_CLASSNAME}`);
  $placeholderDiv && $placeholderDiv.remove();
};

export const enableStickyElementMobile = () => {
  if (isLMPArticle) {
    $player.style.position = 'fixed';
  } else {
    $mediaWrapper.classList.add(MEDIA_WRAPPER_STICKY_PLAYER_CLASSNAME);
    $mediaWrapper.style.top = `${MOBILE_STICKY_WRAPPER_TOP_VALUE}px`;
    if (!isReadingProgressInPage()) {
      $mediaWrapper.classList.add(MEDIA_WRAPPER_TOP_BG_CLASSNAME);
    }
  }
};

export const disableStickyElementMobile = () => {
  if (isLMPArticle) {
    $player.style.position = 'relative';
  } else {
    removePlaceholderDiv();
    $mediaWrapper.style.removeProperty('top');
    $mediaWrapper.classList.remove(MEDIA_WRAPPER_STICKY_PLAYER_CLASSNAME);
    if (!isReadingProgressInPage()) {
      $mediaWrapper.classList.remove(MEDIA_WRAPPER_TOP_BG_CLASSNAME);
    }
  }
};

export const removeCloseButton = () => {
  const closeButton = $player.querySelector('.c-player-card__close');
  closeButton && closeButton.remove();
};

const renderCloseButton = () => {
  const $closeButton = document.createElement('a');
  $closeButton.classList.add('c-player-card__close', 'j-player-card__close');
  $closeButton.innerHTML =
    '<i class="icon icon--navigation icon--close icon--xsmall icon--c-light"><svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--close" fill="currentColor" width="80" height="80"><path d="M39.8 31.84L71.64 0l7.96 7.96L47.76 39.8 80 72.04 72.04 80 39.8 47.76 7.96 79.6 0 71.64 31.84 39.8.4 8.36 8.36.4 39.8 31.84z" fill="currentColor" fill-rule="evenodd"></path></svg></i>';
  return $closeButton;
};

export const appendCloseButton = (players, setHasUserRejectedSticky) => {
  const $existingCloseButton = $player.querySelector('.c-player-card__close');

  if ($existingCloseButton) {
    return;
  }
  const playerInstance = getVideoPlayer(players);
  const $closeButton = renderCloseButton();
  $player.appendChild($closeButton);

  $closeButton.addEventListener('click', () => {
    playerInstance.pause();
    removeCloseButton();
    disableStickyElementAttributes(players);
    if (isWidthDeviceMobileTablet()) {
      disableStickyElementMobile();
    } else {
      disableStickyElementDesktop();
    }
    setHasUserRejectedSticky(true);
  });
};
